if (process.env.NODE_ENV === 'development') {
	// Must use require here as import statements are only allowed
	// to exist at the top of a file.
	require('preact/debug');
}

import '../scss/main.scss';
import { render, h } from 'preact';
import PlotMapApp from './components/PlotMapApp/PlotMapApp';

const addQueryParamsToUrl = (url, queryParams) => {
	const urlInstance = new URL(url);
	const searchParams = urlInstance.searchParams;
	queryParams.forEach(queryParam => {
		searchParams.append(queryParam.key, queryParam.value);
	});
	return urlInstance.origin + urlInstance.pathname + '?' + searchParams.toString() + urlInstance.hash;
};

window.addEventListener('DOMContentLoaded', () => {
	let plotMapAppContainers = document.querySelectorAll('.plot-map-app-root-container');

	if (plotMapAppContainers.length < 1) {
		return;
	}

	plotMapAppContainers = [].slice.call(plotMapAppContainers);

	plotMapAppContainers.forEach(container => {
		render(
			<PlotMapApp
				id={container.getAttribute('data-module-id')}
				fetchGroupsUrl={addQueryParamsToUrl(ajax_url_get_module_plot_map_groups, [{
					key: 'module-id',
					value: container.getAttribute('data-module-id')
				}])}
				fetchPlotNumbersUrl={addQueryParamsToUrl(ajax_url_get_module_plot_map_plot_numbers, [{
					key: 'module-id',
					value: container.getAttribute('data-module-id')
				}])}
				fetchFiltersUrl={container.hasAttribute('data-is-filter-active') ? addQueryParamsToUrl(ajax_url_get_module_filters, [{
					key: 'module-id',
					value: container.getAttribute('data-module-id')
				}]) : undefined}
				filterOnBoarding={JSON.parse(container.getAttribute('data-filter-onboarding'))}
				statusLegendDefaults={JSON.parse(container.getAttribute('data-active-status-highlight'))}
				informationToShowForAPlot={JSON.parse(container.getAttribute('data-plot-info-to-show'))}
				registerButtonLink={{
					url: container.getAttribute('data-register-button-url'),
					label: container.getAttribute('data-register-button-label')
				}}
				placeholderBackgroundImageSrc={container.getAttribute('data-map-placeholder-background-image-src')}
				displayLotNumbers={!!container.getAttribute('data-display-lot-numbers')}
			/>,
			container
		);
	});
});